import { Box, SxProps, Typography } from "@mui/material";

type IStatusBox = {
  icon: JSX.Element,
  color: string,
  backgroundColor: string,
  border: string,
  label: string
  key?: string,
  id?: string,
  tabIndex?: number,
  sxBox?: SxProps,
  sxTypo?: SxProps,
  /** Testo per screen reader quando il badge è di sola icona e `label` resta vuota. */
  ariaLabel?: string,
}

export const StatusBox = ({
  key = "",
  id = "",
  tabIndex = -1,
  sxBox,
  sxTypo,
  icon,
  color,
  backgroundColor,
  border,
  label,
  ariaLabel
}: IStatusBox) => {


  const slug = (ariaLabel || label).toString().toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "") || "status";
  return (
    <Box
      key={ key }
      id={ id ? `status-box-${id}-${slug}` : `status-box-${slug}` }
      data-testid="status-box-container"
      role="group"
      aria-label={ ariaLabel || label }
      tabIndex={ tabIndex }
      sx={ {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "1.5625rem",
        padding: "0.125rem 0.44rem",
        gap: "0.25rem",
        border: border ?? "none",
        backgroundColor: backgroundColor,
        borderRadius: "0.25rem",
        ...sxBox
      } }
    >
      <Typography
        data-testid="status-box-label"
        tabIndex={ -1 }
        id={ `${id}-card-statusBox` }
        sx={ { 
          fontSize: "0.75rem", 
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          gap: "0.44rem",
          ...sxTypo
        } }
        color={ color }
      >
        { icon }
        { label }
      </Typography>
    </Box>
  );
};
